module.exports = __webpack_public_path__ + "img/cdk.d3df7454.png";